import StoryRiverView from 'src/components/StoryRiverView'
import { useSelector } from 'react-redux'
import { getViewByName } from 'src/features/views/ViewsSelector'
import useViewProps from 'src/hooks/useViewProps'

const Iav = () => {
  const title = 'Insight, Analysis & Views'
  const view = useSelector(getViewByName('insight analysis and views')) || null
  const { viewsError, viewsLoading, handleViewMoreClick } = useViewProps()

  return (
    <StoryRiverView
      view={view}
      viewsError={viewsError}
      viewsLoading={viewsLoading}
      handleViewMoreClick={() => handleViewMoreClick('home', title)}
      title={title}
      viewMore={{
        to: '/river/iav',
        show: true,
        handleMore: 'Insights Analysis and Views'
      }}
      sidebar={true}
      titleMode="subheading"
      showTeaser={false}
      showPublished={false}
      tagsClickable={true}
    />
  )
}

export default Iav
